const KastnerStore = (state = [],action) => {

  let rtn

  ///console.log('KastnerStore',action);

  switch (action.type) {

      case 'ADD_WORK_DATA' :


        // Join arrays
           let work = (state.workData)? state.workData.data : []


                work = work.concat(action.payload)



         rtn = {
            ...state,
            workData : { data : work}

         }

        return rtn;

      case 'ADD_OPTIONS_DATA' :


        rtn = {
            ...state,
            optionsData : { data : action.payload.acf}
         }

        return rtn;


      case 'ADD_PAGES_DATA' :


        rtn = {
            ...state,
            pagesData : { data : action.payload}
         }

        return rtn;

      case 'ADD_OFFICES_DATA' :


          rtn = {
              ...state,
              officesData: { data : action.payload}
           }

          return rtn;

    case 'ADD_CLIENTS_DATA' :


        rtn = {
            ...state,
            clientsData: { data : action.payload}
         }

        return rtn;

      case 'ADD_TESTIMONIAL_DATA' :


          rtn = {
              ...state,
              testimonialData : { data : action.payload}
           }

       case 'ADD_CAREERS_DATA' :


           rtn = {
               ...state,
               careersData : { data : action.payload}
            }

          return rtn;
      case 'ADD_NEWS_DATA' :


          rtn = {
              ...state,
              newsData : { data : action.payload}
           }

         return rtn;

       case 'SELECT_LANGUAGE' :

         rtn = {
             ...state,
             currentLanguage : { data : action.payload}
          }

         return rtn;

      default :
        return state

  }

}

export default KastnerStore



// WEBPACK FOOTER //
// ./src/reducers/KastnerStore.js